<app-template>


  <app-base-list *ngIf="data" [filters]="crudService.filters" [filterLabels]="crudService.filterLabels" [sortBy]="crudService.orderBy" [sortDirection]="crudService.orderDirection" [tableConfig]="tableConfig" [data]="data" (action)="onAction($event.name, $event.data)"></app-base-list>

</app-template>
